"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Flex = void 0;
const react_1 = __importDefault(require("react"));
const DIRECTION = Object.freeze({
    ROW: 'row',
    COLUMN: 'column',
});
const POSITION = Object.freeze({
    START: 'flex-start',
    CENTER: 'center',
    BASELINE: 'baseline',
    END: 'flex-end',
    SPC_BETWEEN: 'space-between',
    SPC_AROUND: 'space-around',
    SPC_EVENLY: 'space-evenly',
});
const FlexForwardRef = ({ direction, flex, wrap, children, justify, align, stretch, grow, shrink, testid, gap, }, ref) => (react_1.default.createElement("div", { ref: ref, "data-testid": testid, style: {
        display: 'flex',
        flex,
        flexDirection: direction,
        flexWrap: wrap,
        justifyContent: justify,
        alignItems: align,
        width: direction === DIRECTION.ROW && stretch ? '100%' : 'auto',
        height: direction === DIRECTION.COLUMN && stretch ? '100%' : 'auto',
        ...(grow && { flexGrow: grow }),
        flexShrink: shrink,
        gap,
    } }, children));
exports.Flex = Object.assign(react_1.default.forwardRef(FlexForwardRef), {
    DIRECTION,
    POSITION,
});
exports.Flex.defaultProps = {
    direction: DIRECTION.ROW,
    flex: '0 1 auto',
    justify: 'normal',
    align: 'normal',
    wrap: 'nowrap',
    stretch: false,
    grow: 0,
    shrink: undefined,
    gap: undefined,
    testid: undefined,
};
